import React from "react";
import { Route, Routes } from "react-router-dom";
import { StateAwareNavigate } from "@components/routes/StateAwareNavigate";
import { Onboarding } from "../onboarding/Onboarding";
import { useRenderCommonRoutes } from "./useRenderCommonRoutes";

export const OnboardingRoutes: React.FC = () => {
    const commonRoutes = useRenderCommonRoutes();

    return (
        <Routes>
            <Route path="/onboarding" element={<Onboarding />} />
            {commonRoutes}

            <Route
                path="*"
                element={<StateAwareNavigate to="/onboarding" replace />}
            />
        </Routes>
    );
};
